import '@/utils/flexible'
import './assets/css/main.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useRecruitStore } from '@/stores/modules/recruit'

import App from './App.vue'
import i18n from './langs/i18n'
import layout from './plugins/layout'
import router from './router'

import { initSentry, setSentryUserInfo } from './utils/sentry'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(layout, {
  router
})
app.use(i18n, {
  router
})

// 初始化 Sentry 错误监控（仅在生产环境）
initSentry(app, router)
setSentryUserInfo()
useRecruitStore(pinia).fetchIsContractedAnchor()

app.mount('#app')
